import {AxiosError} from 'axios';
import {ConfigurationType} from 'web-library/models/DropDown';
import {useCustomQuery} from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GET_EXEMPTION_RULES_DROPDOWN_URL} from '../../constants/apiUrls';
import {GET_EXEMPTION_RULES_DROPDOWN_QUERY_KEY} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: ConfigurationType[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetExemptionRulesDropdown = ({onSuccess, onError}: Input = {}) => {
  const getExemptionRulesDropdown = async () => {
    const res = await axiosClient.get<ConfigurationType[]>(GET_EXEMPTION_RULES_DROPDOWN_URL);
    return res.data;
  };

  return useCustomQuery(GET_EXEMPTION_RULES_DROPDOWN_QUERY_KEY, getExemptionRulesDropdown, {
    onSuccess,
    onError,
  });
};
